import { InMemoryCache, InMemoryCacheConfig } from '@apollo/client';

const cache = new InMemoryCache();

export default cache;
